import { Credit, Job, Payment } from '@kanda-libs/ks-frontend-services';

import { LenderStatus } from '../constants';

export const getPropensioState = (
  job: Job,
  credit: Credit,
  deposit?: Payment,
): LenderStatus => {
  const jobFinanceStatus = job?.finance_status || '';
  const financeStatus = credit?.state || '';
  if (['paid', 'payout_pending']?.includes(jobFinanceStatus)) return 'finished';
  if (['sat_note_lender_review', 'sat_note_signed']?.includes(jobFinanceStatus))
    return 'lender_review';
  if (jobFinanceStatus === 'sat_note_delayed') return 'sat_note_delayed';
  if (jobFinanceStatus?.startsWith('sat_note')) return 'sat_note';
  if (jobFinanceStatus === 'under_review') return 'under_review';
  if (jobFinanceStatus === 'finance_cancelled' || financeStatus === 'cancelled')
    return 'cancelled';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'action_customer'
  )
    return 'action_required';
  // DEV_NOTE: Action lender is currently referred
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'action_lender'
  )
    return 'referred';
  if (jobFinanceStatus === 'applied_for_finance' && financeStatus === 'pending')
    return 'pending';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'referred'
  )
    return 'referred';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'declined'
  )
    return 'declined';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'accepted'
  )
    return 'sign_documents';
  if (jobFinanceStatus === 'finance_not_approved') return 'not_approved';
  if (
    jobFinanceStatus === 'financed' &&
    deposit?.payment_option?.payment_method === 'cash'
  )
    return 'ready_to_start';
  if (jobFinanceStatus === 'financed' && deposit?.status === 'paid')
    return 'ready_to_start';
  if (jobFinanceStatus === 'financed' && deposit?.status === 'unpaid')
    return 'deposit';
  return 'loading';
};
